import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, } from 'body-scroll-lock';
import { scroller, animateScroll } from 'react-scroll';
import { CLASS_NAME_HEADER } from '@/utils/constants/element/layout';
export class ScrollLock {
    constructor(selector) {
        this.enable = () => {
            enableBodyScroll(this.elementRef.current);
        };
        this.disable = () => {
            disableBodyScroll(this.elementRef.current, {
                allowTouchMove: (el) => {
                    let checkElement = el;
                    while (checkElement && checkElement !== document.body) {
                        const ignore = checkElement.dataset.bodyScrollLockIgnore;
                        if (ignore) {
                            return true;
                        }
                        checkElement = checkElement.parentNode;
                    }
                    return false;
                },
            });
        };
        this.clear = () => {
            clearAllBodyScrollLocks();
        };
        if (typeof selector === 'string') {
            this.elementRef = {
                current: document.querySelector(selector),
            };
        }
        else {
            this.elementRef = selector;
        }
    }
}
export const smoothScrollTo = (name, options) => scroller.scrollTo(name, Object.assign({ smooth: true }, options));
export const scrollToTop = () => animateScroll.scrollToTop();
// ヘッダー部分の高さを考慮してscrollする
export const scrollToWithHeaderHeight = (name, args) => {
    const options = Object.assign({ offset: 0, smooth: true }, args);
    const headerDom = document.querySelector(`.${CLASS_NAME_HEADER}`) || {};
    const height = headerDom.offsetHeight || 0;
    options.offset -= height;
    return scroller.scrollTo(name, options);
};
// 指定されたname位置が画面内に存在しない場合のみスクロールする関数
export const scrollToTarget = (name) => {
    const headerDom = document.querySelector(`.${CLASS_NAME_HEADER}`) || {};
    const height = headerDom.offsetHeight || 0;
    const header = document.querySelector('header');
    const headerHeight = header ? header.clientHeight : 0;
    const start = window.pageYOffset + headerHeight;
    const end = window.innerHeight + window.pageYOffset;
    const targetElement = document.querySelector(`.${name}`);
    const targetPos = targetElement && targetElement.getBoundingClientRect().top + window.scrollY;
    if (targetElement &&
        (targetPos < 0 || !(start < targetPos && targetPos < end))) {
        smoothScrollTo(name, { offset: -height * 1.5 });
    }
};
